module.exports = __webpack_public_path__ + "img/bj_findzanwu@2x.ec1eddad.png";